/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import { injectIntl } from 'react-intl'

import Card from 'generic/card/Card'
import ApplicantList from './ApplicantList'
import ApplicantForm from './ApplicantForm'

import * as constants from 'constants/Header'
import * as userActions from 'actions/User'

class ApplicantPage extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      rightIcon: undefined,
      applicant: undefined,
      userTypeViews: []
    }

    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    userActions.getUserTypeViews()
      .then((result) => {
        this.setState({
          userTypeViews: result.data.objects.objects
        })
      })
  }

  handleChange(name, value) {
    this.setState({
      [name]: value
    })
  }

  render () {
    return (
      <Card
        title={this.props.intl.formatMessage(constants.messages.APPLICANT_LIST_MENU)}
        rightIcon={this.state.rightIcon}
        style={{
          width: '98%',
        }}
      >
        {
          !this.state.applicant
            ? <ApplicantList
              handleChange={this.handleChange}
            />
            : <ApplicantForm
              handleChange={this.handleChange}
              applicant={this.state.applicant}
              userTypeViews={this.state.userTypeViews}
            />
        }
      </Card>
    )
  }
}

export default injectIntl(ApplicantPage)



// WEBPACK FOOTER //
// ./src/components/staff/ApplicantPage.js